export default __webpack_public_path__ + "static/media/bg-h5.ae679535.png";